var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCube = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 30,
    height: 30,
    rx: 6,
    fill: "#1B5482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 23V15C27.9996 14.6493 27.9071 14.3048 27.7315 14.0012C27.556 13.6975 27.3037 13.4454 27 13.27L20 9.26999C19.696 9.09446 19.3511 9.00204 19 9.00204C18.6489 9.00204 18.304 9.09446 18 9.26999L11 13.27C10.6963 13.4454 10.444 13.6975 10.2685 14.0012C10.0929 14.3048 10.0004 14.6493 10 15V23C10.0004 23.3507 10.0929 23.6952 10.2685 23.9988C10.444 24.3025 10.6963 24.5546 11 24.73L18 28.73C18.304 28.9055 18.6489 28.9979 19 28.9979C19.3511 28.9979 19.696 28.9055 20 28.73L27 24.73C27.3037 24.5546 27.556 24.3025 27.7315 23.9988C27.9071 23.6952 27.9996 23.3507 28 23Z",
    stroke: "#F6F8F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2695 13.96L18.9995 19.01L27.7295 13.96",
    stroke: "#F6F8F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 29.08V19",
    stroke: "#F6F8F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cube.1233742e.svg";
export { ForwardRef as ReactComponent };